import React from 'react'

const IconActive = props => (
  <svg className={`icon-active ${props.service}`} width="98" height="98" viewBox="0 0 210 210" fill="none" xmlns="http://www.w3.org/2000/svg">
    <title>Active Service</title>
    <path fill="#f8f8fa" fill-rule="evenodd" clip-rule="evenodd" d="M209.016 0.984009L0.984009 209.016H209.016V0.984009ZM156.718 123.833C154.737 123.29 152.652 123 150.5 123C137.53 123 127 133.53 127 146.5C127 159.47 137.53 170 150.5 170C163.303 170 173.728 159.74 173.995 147H179.996C179.727 163.052 166.614 176 150.5 176C134.219 176 121 162.781 121 146.5C121 130.219 134.219 117 150.5 117C154.365 117 158.058 117.745 161.442 119.099L156.718 123.833ZM147.49 149.469L139.384 141.362L135.141 145.605L143.248 153.711L143.24 153.719L147.483 157.962L147.49 157.954L147.498 157.962L151.74 153.719L151.733 153.711L176.439 129.005L172.197 124.763L147.49 149.469Z" />
  </svg>
)

export default IconActive
